import axios from 'axios';
import { loadConfig, getConfig } from '../../runtimeConfig';

// Create axios instance — the baseURL is set lazily after config.json loads
// so we always use the runtime config, not the stale build-time env var.
export const api = axios.create({ timeout: 600000 }); // 10 min — DB2 queries can take 5+ min on cold start

// Interceptor: ensure every request uses the live config URL
let _resolvedBase: string | null = null;
api.interceptors.request.use(async (config) => {
  if (!_resolvedBase) {
    try {
      const cfg = await loadConfig();
      _resolvedBase = cfg.REACT_APP_API;
    } catch {
      _resolvedBase = getConfig().REACT_APP_API;
    }
  }
  // Only prepend if the URL is relative (starts with /)
  if (config.url && config.url.startsWith('/')) {
    config.url = _resolvedBase + config.url;
  } else if (config.url && !config.url.startsWith('http')) {
    config.url = _resolvedBase + '/' + config.url;
  }
  return config;
});

/**
 * Filters are MULTI-SELECT — each is an array of selected values.
 * An empty array means "All" (no filter applied).
 *
 *  warehouses  — list of warehouse codes (e.g. ['JED','JDA'])
 *  chambers    — list of STORAGE_AREA codes (CH = Area, e.g. ['11-01','12-03'])
 *  palletTypes — list of pallet type codes (e.g. ['iso','euro'])
 */
export type Filters = {
  warehouses: string[];
  chambers: string[];
  palletTypes: string[];
};

export const EMPTY_FILTERS: Filters = { warehouses: [], chambers: [], palletTypes: [] };
